export const CURRENCIES = {
  EUR: 'EUR (€)',
  GBP: 'GBP (£)',
  USD: 'USD ($)',
};
